import FocusAreaBonesAndJoints from '../assets/images/pdf/focus-areas/focus-area-bones-and-joints-5-1.webp';
import FocusAreaDigestion from '../assets/images/pdf/focus-areas/focus-area-digestion-5-1.webp';
import FocusAreaEnergy from '../assets/images/pdf/focus-areas/focus-area-energy-5-1.webp';
import FocusAreaEyes from '../assets/images/pdf/focus-areas/focus-area-eyes-5-1.webp';
import FocusAreaFocus from '../assets/images/pdf/focus-areas/focus-area-focus-5-1.webp';
import FocusAreaHair from '../assets/images/pdf/focus-areas/focus-area-hair-5-1.webp';
import FocusAreaHeart from '../assets/images/pdf/focus-areas/focus-area-heart-5-1.webp';
import FocusAreaImmuneSystem from '../assets/images/pdf/focus-areas/focus-area-immune-system-5-1.webp';
import FocusAreaMood from '../assets/images/pdf/focus-areas/focus-area-mood-5-1.webp';
import FocusAreaMusclePain from '../assets/images/pdf/focus-areas/focus-area-muscle-pain-5-1.webp';
import FocusAreaNails from '../assets/images/pdf/focus-areas/focus-area-nails-5-1.webp';
import FocusAreaSkin from '../assets/images/pdf/focus-areas/focus-area-skin-5-1.webp';
import FocusAreaSleep from '../assets/images/pdf/focus-areas/focus-area-sleep-5-1.webp';
import FocusAreaSportPerformance from '../assets/images/pdf/focus-areas/focus-area-sport-performance-5-1.webp';
import FocusAreaStress from '../assets/images/pdf/focus-areas/focus-area-stress-5-1.webp';

import IconBonesAndJoints from '../assets/images/pdf/focus-areas-icon/bones-and-joints-icon-white.webp';
import IconDigestion from '../assets/images/pdf/focus-areas-icon/digestion-icon-white.webp';
import IconEnergy from '../assets/images/pdf/focus-areas-icon/energy-icon-white.webp';
import IconEyes from '../assets/images/pdf/focus-areas-icon/eyes-icon-white.webp';
import IconFocus from '../assets/images/pdf/focus-areas-icon/focus-icon-white.webp';
import IconHair from '../assets/images/pdf/focus-areas-icon/hair-icon-white.webp';
import IconHeart from '../assets/images/pdf/focus-areas-icon/heart-icon-white.webp';
import IconImmuneSystem from '../assets/images/pdf/focus-areas-icon/immune-system-icon-white.webp';
import IconMood from '../assets/images/pdf/focus-areas-icon/mood-icon-white.webp';
import IconMusclePain from '../assets/images/pdf/focus-areas-icon/muscle-pain-icon-white.webp';
import IconNails from '../assets/images/pdf/focus-areas-icon/nails-icon-white.webp';
import IconSkin from '../assets/images/pdf/focus-areas-icon/skin-icon-white.webp';
import IconSleep from '../assets/images/pdf/focus-areas-icon/sleep-icon-white.webp';
import IconSportPerformance from '../assets/images/pdf/focus-areas-icon/sport-performance-icon-white.webp';
import IconStress from '../assets/images/pdf/focus-areas-icon/stress-icon-white.webp';

// export const MICRO_INGREDIENT_IDS = [25, 18, 20, 26, 28, 30]; // Chromium 5 , Selenium 17
//
// Ids dosed in micrograms. Every consumer uses this the same way — multiply the
// stored mg quantity by 1000 and print µg instead of mg — so an id missing here
// is declared in mg on the label.
//
// 37 (Iodine from Fucus) was missing until SHI-554. Its eu_nrv is 0.15 mg = 150 µg,
// the same order as B12 (0.0025) and D3 (0.005), so it belongs here: iodine was
// printing as "0.15 mg" where EU 1169/2011 Annex XIII expects "150 µg". The number
// was right, the unit convention was not. riise-web and riise-partner already had
// 37 in their copies of this list; admin — the only repo that actually prints
// labels — had drifted.
export const MICRO_INGREDIENT_IDS = [25, 18, 20, 26, 28, 30, 33, 34, 37];
export const kcal_per_g_carbs = 4;
export const kj_per_g_carbs = 17;
export const EXTRA_UNITS = {
  18: 'RE', // Vitamin A
  22: 'NE', // Vitamin B3
  29: 'a-TE', // Vitamin E
};
export const CONSTANTS = {
  Enerygy: 2000, // kcal
  TotalFats: 70, // g
  Saturates: 20, // g
  Carbohydrates: 260, // g
  Sugars: 90, // g
  Protein: 50, // g
  Salt: 6, // g
};

export const FOCUS_AREA_MEDIA = [
  { name: ['Focus', 'Schwerpunkt'], img: FocusAreaFocus, icon: IconFocus },
  { name: ['Energy', 'Energie'], img: FocusAreaEnergy, icon: IconEnergy },
  {
    name: ['Sport Performance', 'Sportliche Leistung'],
    img: FocusAreaSportPerformance,
    icon: IconSportPerformance,
  },
  { name: ['Mood', 'Stimmung'], img: FocusAreaMood, icon: IconMood },
  { name: ['Stress'], img: FocusAreaStress, icon: IconStress },
  {
    name: ['Immune System', 'Immunsystem'],
    img: FocusAreaImmuneSystem,
    icon: IconImmuneSystem,
  },
  { name: ['Sleep', 'Schlaf'], img: FocusAreaSleep, icon: IconSleep },
  {
    name: ['Digestion', 'Verdauung'],
    img: FocusAreaDigestion,
    icon: IconDigestion,
  },
  { name: ['Skin', 'Haut'], img: FocusAreaSkin, icon: IconSkin },
  { name: ['Nails', 'Nägel'], img: FocusAreaNails, icon: IconNails },
  { name: ['Hair', 'Haare'], img: FocusAreaHair, icon: IconHair },
  { name: ['Heart', 'Herz'], img: FocusAreaHeart, icon: IconHeart },
  {
    name: ['Muscle Pain', 'Muskelschmerzen'],
    img: FocusAreaMusclePain,
    icon: IconMusclePain,
  },
  {
    name: ['Bones and Joints', 'Knochen und Gelenke'],
    img: FocusAreaBonesAndJoints,
    icon: IconBonesAndJoints,
  },
  { name: ['Eyes', 'Augen'], img: FocusAreaEyes, icon: IconEyes },
];
